<template>
  <cs-preloader-overlay :loading="loading">
    <div class="wide">
      <div
        class="wrap-container"
        :class="{
          'full-size': subscription.bill_image_link && isDeviceSize.laptop
        }"
      >
        <div :class="$style.header">
          <project-header
            :project="subscription"
            :language="getLanguage"
          />
        </div>

        <div v-if="subscription.bill_image_link" class="side wrap-box">
          <div id="previewScrollable" class="preview" @click="showPreview">
            <img :src="subscription.bill_image_link" class="preview-img" alt="" />
          </div>

          <div
            v-if="!isVisibleDescription"
            class="comment"
            :class="{ 'hidden': !subscription.bill_description }"
          >
            <p>{{ getDescription() }}</p>
            <p
              v-if="showSliceButton"
              class="comment-toggler"
              @click="slicedDescription = !slicedDescription"
            >
              {{ displayToggleText }}
            </p>
          </div>
        </div>

        <div class="container wrap-box">
          <div
            v-if="isVisibleDescription"
            class="comment separate"
            :class="{ 'hidden': !subscription.bill_description }"
          >
            <p>{{ getDescription() }}</p>
            <p
              v-if="showSliceButton"
              class="comment-toggler"
              @click="slicedDescription = !slicedDescription"
            >
              {{ displayToggleText }}
            </p>
          </div>

          <template v-if="subscription">
            <applicable-tariff
              v-if="!subscription.subscriptionTokenBinding"
              v-m-b="10"
              :tariff="subscription"
              :payments-enabled="project.paymentsEnabled"
              no-interactive
            />
            <subscription-card
              :subscription="subscription"
              @unfollow="onUnfollow"
            />
          </template>

          <footer-section />
        </div>
      </div>
    </div>
  </cs-preloader-overlay>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';

import ProjectHeader from 'organisms/project/ProjectHeader';
import ApplicableTariff from 'organisms/tariff/ApplicableTariff';

import SubscriptionCard from '../components/SubscriptionCard';

const SLICE_LENGTH = 100;

export default {
  name: 'Subscription',
  components: {
    ProjectHeader,
    ApplicableTariff,
    SubscriptionCard,
  },
  created() {
    this.loadData();
  },
  data() {
    return {
      loading: false,
      slicedDescription: true,
    };
  },
  computed: {
    isVisibleDescription() {
      let mask = '';
      mask += this.isDeviceSize.mobile ? 1 : 0;
      mask += this.subscription.bill_image_link ? 1 : 0;
      mask += this.subscription.bill_description ? 1 : 0;

      if (/011|011/.test(mask)) {
        return false;
      }

      return true;
    },
    showSliceButton() {
      return this.subscription.bill_description && this.subscription.bill_description.length > SLICE_LENGTH;
    },
    displayToggleText() {
      return this.slicedDescription ? 'Подробнее' : 'Скрыть';
    },
    getPasswordCard() {
      return sessionStorage.getItem('passwordCard');
    },
    getPaymentId() {
      return sessionStorage.getItem('paymentId');
    },
    getAccessToken() {
      return sessionStorage.getItem('accessToken');
    },
    project() {
      return {
        currency: this.TRANSACTION.currency,
        paymentsEnabled: this.TRANSACTION.paymentsEnabled,
      };
    },
    ...mapState(['TRANSACTION']),
    ...mapGetters(['isDeviceSize', 'getLanguage']),
    ...mapGetters('subscription', ['subscription']),
  },
  methods: {
    async loadData() {
      this.loading = true;

      const payload = {
        paymentId: this.getPaymentId,
        password: this.getPasswordCard,
        token: this.getAccessToken,
      };

      await this.subscriptionAccess(payload);
      await this.GET_PROJECT_LOCALE({ publicId: this.getPaymentId });

      this.loading = false;
    },
    async onUnfollow() {
      try {
        await this.subscriptionCancel(this.subscription.paymentId);
        this.loadData();
      } catch (error) {
        console.log(error);
      }
    },
    showPreview() {
      document.getElementById('previewScrollable').classList.toggle('preview-open');
    },
    getDescription() {
      if (!this.subscription.bill_description) {
        return '';
      }
      if (!this.slicedDescription) {
        return this.subscription.bill_description;
      }
      if (this.subscription.bill_description.length > SLICE_LENGTH) {
        return `${this.subscription.bill_description.substr(0, SLICE_LENGTH)}...`;
      }
      return this.subscription.bill_description;
    },
    ...mapActions(['GET_PROJECT_LOCALE']),
    ...mapActions('subscription', ['subscriptionAccess', 'subscriptionCancel']),
  },
};
</script>

<style lang="sass" module>
  .header
    width: 100%
    padding: 30px 0

    +respond-to('medium')
      padding: 40px 0
</style>

<style lang="sass" scoped>
  .comment
    p
      font-size: 14px
      line-height: 20px
      color: #212121

    &.separate
      margin-bottom: 10px
      box-shadow: 0px 1px 2px rgba(189, 189, 189, 0.5)

    p.comment-toggler
      color: #9b51e0
      cursor: pointer
</style>
